export const getUrlString = (url: any) => {
  const urlString = Array.isArray(url) ? url[0] : url
  return urlString
}

export const contactTypeUrl = (type: string, contact: string) => {
  if (type === 'phone') {
    const phone = contact.replace(/[^\d]/g, '')
    return `tel:${phone}`
  } else if (type === 'email') {
    return `mailto:${contact}`
  } else if (type === 'whatsapp') {
    const phone = contact.replace(/[^\d]/g, '')
    return `https://wa.me/55${phone}`
  }
  return contact
}
